import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faPlus, faUser } from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardText,
  Col,
  Collapse,
  FormGroup,
  Row,
  Fade,
} from "reactstrap";
import Paginate from "./../common/pagination";
import usePost from "../../services/usePost";
import useGet from "../../services/useGet";
import SOURCES from "../../utils/constants";
import useDebounce from "../../utils/customHooks";
import LowActivityUsersDetail from "./modules/lowActivityUsersDetail";
import { yupValidationSchema } from "../../utils/functions";
import HeaderSearchInput from "../common/headerSearchInput";


const LowActivityUsers = () => {
  const [pagination, setPagination] = useState({
    offset: 0,
    limit: SOURCES.DEFAULT_RECORDS_LISTING,
  });


  const [userList, setUserlist] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [showDetail, setshowDeatail] = useState(false);
  const [leadDetail, setLeadDetail] = useState(null);
  const [deleteId, setDeleteId] = useState();
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState(1);



  const [userInfo, setUserInfo] = useState({
    name: "",
    company: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    plan: "",
    coupon: "",
  });

  const {
    callApi: getUsers,
    data: users,
    isLoading: usersLoading,
  } = useGet({
    endpoint: `admin/lowActivityUsers?offset=${pagination.offset}&limit=${pagination.limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
  });

  const {
    callApi: getSearchData,
    data: searchData,
    isLoading: searchDataLoading,
  } = useGet({
    endpoint: `admin/lowActivityUsers/search?q=${searchInput}`,
  });



  const { callApi: accountStatus, processSuccess } = usePost({
    endpoint: `admin/status`,
  });


  useEffect(() => {
    getUsers();

  }, [
    pagination.offset,
    pagination.limit,
    sortBy,
    sortOrder,

  ]);

  const debouncedSearchTerm = useDebounce(searchInput, 500);


  useEffect(() => {
    if (debouncedSearchTerm && debouncedSearchTerm.length >= 2) getSearchData();
    else if (!debouncedSearchTerm) getUsers();
  }, [debouncedSearchTerm]);


  useEffect(() => {
    setUserlist(users.users);
    if (searchData && searchInput) setUserlist(searchData?.users);


    setUserInfo({
      name: "",
      company: "",
      phone: "",
      email: "",
      password: "",
      confirmPassword: "",
      plan: "",
      coupon: "",
    });

  }, [users, searchData]);

  const handleOnChange = async (e) => {
    const term = e.target.value;
    if (term.length >= 2) {
      setSearchInput(term);
    } else {
      if (term.length === 0) setSearchInput("");
    }
  };

  const isLoading =
    usersLoading || searchDataLoading;

  return (
    <div>


      <Fade>
        <Card color="shadow" className={`${showDetail ? "d-none" : "d-block"}`}>
          <CardBody>
          <CardTitle tag="h4">
              <Row className="d-flex justify-content-between align-items-center">
                {/* Left Side - Title */}
                <Col>
                  <FontAwesomeIcon icon={faUser} className="mr-2" />
                  Low Activity Users
                </Col>

                {/* Right Side - Search Input */}
                <Col xs="auto">
                  <HeaderSearchInput onChange={handleOnChange} />
                </Col>
              </Row>
            </CardTitle>

            <CardSubtitle className="mb-2 text-muted" tag="h6"></CardSubtitle>
            <CardText>
              <LowActivityUsersDetail
                userList={userList}
                isLoading={isLoading}
                leadDetail={leadDetail}
                setshowDeatail={setshowDeatail}
                showDetail={showDetail}
                setLeadDetail={setLeadDetail}
                getUsers={getUsers}
                getSearchData={getSearchData}
                searchInput={searchInput}
                accountStatus={accountStatus}
                processSuccess={processSuccess}
                setDeleteId={setDeleteId}
                deleteId={deleteId}
                setSortBy={setSortBy}
                sortBy={sortBy}
                setSortOrder={setSortOrder}
                sortOrder={sortOrder}
              />
            </CardText>
          </CardBody>

          <div className="px-4">
            {!searchInput && users?.count > SOURCES.DEFAULT_RECORDS_LISTING && (
              <FormGroup>
                <Paginate setPagination={setPagination} totalRecords={users?.count} isLoading={isLoading} />
              </FormGroup>
            )}
          </div>
        </Card>
      </Fade>


    </div>
  );
};

export default LowActivityUsers;
